import { render, staticRenderFns } from "./uploadQuestion.vue?vue&type=template&id=1fbe16fe&scoped=true&"
import script from "./uploadQuestion.vue?vue&type=script&lang=js&"
export * from "./uploadQuestion.vue?vue&type=script&lang=js&"
import style0 from "./uploadQuestion.vue?vue&type=style&index=0&id=1fbe16fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbe16fe",
  null
  
)

export default component.exports